import React, { useState, useEffect, useRef } from "react";
import ScoreComponent from "./ScoreComponent";
import PenaliteComponent from "./PenaliteComponent";
import OsaekomiComponent from "./OsaekomiComponent";
import MainChronoComponent from "./MainChronoComponent";
import ControlButtonsComponent from "./ControlButtonsComponent";
import DetermineWinnerModal from "./DetermineWinnerModal";
import { FaMedkit } from "react-icons/fa";
import { getCompetitionSettingsByCompetitionId } from "../../services/competitionsettingsServices"; // 👈 importer
import getCategory from "../../utils/getCategory";
import socket from "./socketClient"; // 👈 importer le client socket
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ScoreboardAdmin = ({
  tapisId,
  competiteur1,
  competiteur2,
  onValidate,
  competitionId, // 👈 ajouter
  categorieAge, // 👈 ajouter
  combatKey,
}) => {
  const [score1, setScore1] = useState({ ippon: 0, wazari: 0, yuko: 0 });
  const [score2, setScore2] = useState({ ippon: 0, wazari: 0, yuko: 0 });
  const [penalites1, setPenalites1] = useState(0);
  const [penalites2, setPenalites2] = useState(0);
  const [osaekomi1, setOsaekomi1] = useState(0);
  const [osaekomi2, setOsaekomi2] = useState(0);

  const [chrono, _setChrono] = useState(180);
  const [isChronoRunning, _setIsChronoRunning] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [forfaitActif1, setForfaitActif1] = useState(false);
  const [forfaitActif2, setForfaitActif2] = useState(false);
  const [goldenScoreMode, setGoldenScoreMode] = useState(false);
  const [goldenChrono, setGoldenChrono] = useState(0);
  const [chronoMax, setChronoMax] = useState(null); // ✅ durée cible

  const [wazariAwaseteIppon, setWazariAwaseteIppon] = useState(false);
  const [ipponMetFin, setIpponMetFin] = useState(false);
  const [deuxIpponFin, setDeuxIpponFin] = useState(false);
  const [pointsMetFin, setPointsMetFin] = useState(false);
  const [pointsFin, setPointsFin] = useState(null);

  // 🔒 Empêche le reset intempestif quand les réglages arrivent
  const userTouchedChronoRef = useRef(false); // l’utilisateur a interagi
  const settingsAppliedRef = useRef(false); // réglages appliqués une fois
  const isRunningRef = useRef(false);
  useEffect(() => {
    isRunningRef.current = isChronoRunning;
  }, [isChronoRunning]);

  // Wrappers qui marquent la main de l’utilisateur
  const setChronoSafe = (v) => {
    userTouchedChronoRef.current = true;
    _setChrono(typeof v === "function" ? v : v);
  };
  const setIsChronoRunningSafe = (v) => {
    userTouchedChronoRef.current = true;
    _setIsChronoRunning(typeof v === "function" ? v : v);
  };

  // Socket - join
  useEffect(() => {
    if (!competitionId || !tapisId) return;

    const room = `${competitionId}_${tapisId}`;
    socket.emit("join_combat", room);
    const data = {
      score1,
      score2,
      penalites1,
      penalites2,
      osaekomi1,
      osaekomi2,
      chrono,
      isChronoRunning,
      goldenScoreMode,
      goldenChrono,
      forfaitActif1,
      forfaitActif2,
      competiteur1,
      competiteur2,
      categorieAge,
      chronoMax, // ✅ chronoMax (pas chrono)
    };
    socket.emit("score_update", { combatId: room, data });
  }, [competitionId, tapisId]);

  // Socket - broadcast
  useEffect(() => {
    if (!competitionId || !tapisId) return;
    const room = `${competitionId}_${tapisId}`;
    const data = {
      score1,
      score2,
      penalites1,
      penalites2,
      osaekomi1,
      osaekomi2,
      chrono,
      isChronoRunning,
      goldenScoreMode,
      goldenChrono,
      forfaitActif1,
      forfaitActif2,
      competiteur1,
      competiteur2,
      categorieAge,
      chronoMax,
    };
    socket.emit("score_update", { combatId: room, data });
  }, [
    score1,
    score2,
    penalites1,
    penalites2,
    osaekomi1,
    osaekomi2,
    chrono,
    isChronoRunning,
    goldenScoreMode,
    goldenChrono,
    forfaitActif1,
    forfaitActif2,
    competiteur1,
    competiteur2,
    competitionId,
    tapisId,
    chronoMax,
    categorieAge,
  ]);

  // Hansoku auto
  useEffect(() => {
    setScore1((prev) => ({ ...prev, hansokuMake: penalites1 === 3 }));
  }, [penalites1]);
  useEffect(() => {
    setScore2((prev) => ({ ...prev, hansokuMake: penalites2 === 3 }));
  }, [penalites2]);

  const playGongSound = () => {
    try {
      const comp = competitionId ?? "any";
      const tatami = tapisId ?? "any";
      const raw = localStorage.getItem(`gongSound:${comp}:${tatami}`);
      let src = "/son/gong.mp3"; // fallback

      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed?.value === "custom" && parsed?.url) {
          src = String(parsed.url).trim() || src;
        } else if (parsed?.value && parsed.value !== "custom") {
          src = String(parsed.value);
        }
      }

      const audio = new Audio(src);
      audio.play().catch(() => {
        // fallback si la ressource est introuvable/non lisible
        const fallback = new Audio("/son/gong.mp3");
        fallback
          .play()
          .catch((e) => console.error("Lecture gong (fallback) échouée :", e));
      });
    } catch (e) {
      console.error("Lecture gong (config locale) échouée :", e);
      const fallback = new Audio("/son/gong.mp3");
      fallback
        .play()
        .catch((err) =>
          console.error("Lecture gong (fallback) échouée :", err)
        );
    }
  };

  // ⚙️ Récup réglages — NE PAS ÉCRASER le chrono si déjà manipulé / en cours
  useEffect(() => {
    const fetchChronoSettings = async () => {
      if (!competitionId || !competiteur1?.ddn_competiteur) return;

      const ageCategory =
        categorieAge || getCategory(competiteur1.ddn_competiteur);
      const categoryToKey = {
        Eveil: "baby",
        "Mini-Poussin(e)": "minipoussin",
        "Poussin(e)": "poussin",
        "Benjamin(e)": "benjamin",
        Minime: "minime",
        "Cadet(te)": "cadet",
        Junior: "junior",
        Sénior: "senior",
        Vétéran: "senior",
      };
      const key = categoryToKey[ageCategory];
      if (!key) return;

      try {
        const settings = await getCompetitionSettingsByCompetitionId(
          competitionId
        );
        const s = settings?.[0] || {};
        const seconds = s?.[`temps_${key}`];

        if (Number.isFinite(Number(seconds))) {
          setChronoMax(Number(seconds)); // toujours à jour
          // 👉 n’appliquer la valeur chrono qu’une seule fois et seulement
          // si l’utilisateur n’a pas déjà touché et si ça ne tourne pas
          if (
            !userTouchedChronoRef.current &&
            !isRunningRef.current &&
            !settingsAppliedRef.current
          ) {
            _setChrono(Number(seconds));
            settingsAppliedRef.current = true;
          }
        }

        if (s?.points_fin != null) setPointsFin(s.points_fin);
        if (s?.wazari_awasete_ippon !== undefined)
          setWazariAwaseteIppon(!!s.wazari_awasete_ippon);
        if (s?.ippon_met_fin !== undefined) setIpponMetFin(!!s.ippon_met_fin);
        if (s?.deux_ippon_fin !== undefined)
          setDeuxIpponFin(!!s.deux_ippon_fin);
        if (s?.points_met_fin !== undefined)
          setPointsMetFin(!!s.points_met_fin);
      } catch (error) {
        console.error("Erreur chargement du temps de combat :", error);
      }
    };

    fetchChronoSettings();
  }, [competitionId, competiteur1?.ddn_competiteur, categorieAge]);

  // Fin de combat auto
  useEffect(() => {
    if (!ipponMetFin) return;
    if (score1.ippon >= 1 || score2.ippon >= 1) {
      toast.info("Fin du combat avec 1 Ippon !!! 🥋");
      setIsChronoRunningSafe(false);
      setTimeout(() => {
        handleValidate();
      }, 500);
    }
  }, [score1.ippon, score2.ippon, ipponMetFin]);

  useEffect(() => {
    if (!deuxIpponFin) return;
    if (score1.ippon >= 2 || score2.ippon >= 2) {
      toast.info("Fin du combat : 2 Ippon atteints 🥋");
      setIsChronoRunningSafe(false);
      setTimeout(() => {
        handleValidate();
      }, 500);
    }
  }, [score1.ippon, score2.ippon, deuxIpponFin]);

  useEffect(() => {
    if (!pointsMetFin || pointsFin === null) return;

    const totalPoints1 =
      score1.ippon * 10 + score1.wazari * 7 + score1.yuko * 5;
    const totalPoints2 =
      score2.ippon * 10 + score2.wazari * 7 + score2.yuko * 5;

    if (totalPoints1 >= pointsFin) {
      toast.info(
        `Fin du combat : ${totalPoints1} pts atteints (≥ ${pointsFin}) 🎯`
      );
      setIsChronoRunningSafe(false);
      setTimeout(() => {
        handleValidate();
      }, 500);
    } else if (totalPoints2 >= pointsFin) {
      toast.info(
        `Fin du combat : ${totalPoints2} pts atteints (≥ ${pointsFin}) 🎯`
      );
      setIsChronoRunningSafe(false);
      setTimeout(() => {
        handleValidate();
      }, 500);
    }
  }, [score1, score2, pointsFin, pointsMetFin]);

  const calculateCombatResult = () => {
    let resultat1 = "N";
    let resultat2 = "N";

    if (score1.forfait)
      return { result1: "F", result2: "V", points1: 0, points2: 10 };
    if (score2.forfait)
      return { result1: "V", result2: "F", points1: 10, points2: 0 };

    if (score1.hansokuMake)
      return { result1: "H", result2: "V", points1: 0, points2: 10 };
    if (score2.hansokuMake)
      return { result1: "V", result2: "H", points1: 10, points2: 0 };

    const score1Total = score1.ippon * 100 + score1.wazari * 10 + score1.yuko;
    const score2Total = score2.ippon * 100 + score2.wazari * 10 + score2.yuko;

    if (score1Total > score2Total) {
      resultat1 = "V";
      resultat2 = "D";
    } else if (score2Total > score1Total) {
      resultat1 = "D";
      resultat2 = "V";
    }

    const rawPoints1 = score1.ippon * 10 + score1.wazari * 7 + score1.yuko * 5;
    const rawPoints2 = score2.ippon * 10 + score2.wazari * 7 + score2.yuko * 5;

    const finalPoints1 =
      pointsFin !== null ? Math.min(rawPoints1, pointsFin) : rawPoints1;
    const finalPoints2 =
      pointsFin !== null ? Math.min(rawPoints2, pointsFin) : rawPoints2;

    return {
      result1: resultat1,
      result2: resultat2,
      points1: finalPoints1,
      points2: finalPoints2,
    };
  };

  const handleValidate = (payloadFromModal) => {
    // Cas 1: la modale nous a déjà construit un payload complet (avec details_combat)
    if (payloadFromModal && typeof payloadFromModal === "object") {
      onValidate({
        ...payloadFromModal,
        // on s’assure de propager aussi les flags locaux
        forfait1: score1?.forfait || false,
        forfait2: score2?.forfait || false,
        hansoku1: score1?.hansokuMake || false,
        hansoku2: score2?.hansokuMake || false,
      });
      return;
    }

    // Cas 2: fallback historique (au cas où on valide sans passer par la modale)
    const results = calculateCombatResult();
    onValidate({
      ...results,
      forfait1: score1?.forfait || false,
      forfait2: score2?.forfait || false,
      hansoku1: score1?.hansokuMake || false,
      hansoku2: score2?.hansokuMake || false,
    });
  };

  // FORFAIT BOUTON COMPETITEUR 1
  const handleForfait1Press = () => {
    const timeout = setTimeout(() => {
      setScore1({ ippon: 0, wazari: 0, yuko: 0 });
      setForfaitActif1(false);
      setModalVisible(false);
    }, 500);
    return timeout;
  };

  const handleForfait1Click = () => {
    if (!forfaitActif1) {
      setScore1({ ippon: 0, wazari: 0, yuko: 0, forfait: true }); // ✅ forfait sur le 1
      setScore2((p) => ({ ...p, ippon: (p.ippon || 0) + 1 })); // ✅ ippon à l’adversaire
      setForfaitActif1(true);
      setModalVisible(true);
    }
  };

  const handleForfait2Press = () => {
    const timeout = setTimeout(() => {
      setScore2({ ippon: 0, wazari: 0, yuko: 0 });
      setForfaitActif2(false);
      setModalVisible(false);
    }, 500);
    return timeout;
  };

  const handleForfait2Click = () => {
    if (!forfaitActif2) {
      setScore2({ ippon: 0, wazari: 0, yuko: 0, forfait: true }); // ✅ forfait sur le 2
      setScore1((p) => ({ ...p, ippon: (p.ippon || 0) + 1 })); // ✅ ippon à l’adversaire
      setForfaitActif2(true);
      setModalVisible(true);
    }
  };

  return (
    <div className="bg-gray-800 text-white shadow-lg h-full w-full mx-auto flex flex-col space-y-2 px-4 py-12">
      <ScoreComponent
        competiteur={competiteur1}
        score={score1}
        setScore={setScore1}
        tapisId={tapisId}
        isRed={true}
        wazariAwaseteIppon={wazariAwaseteIppon}
      />
      <div className="flex justify-between">
        <div className="flex justify-center items-center gap-2 sm:space-x-4 sm:gap-0">
          <PenaliteComponent
            penalites={penalites1}
            setPenalites={setPenalites1}
            tapisId={tapisId}
            competiteur={1}
          />
          <button
            onMouseDown={() =>
              (window._forfait1Timeout = handleForfait1Press())
            }
            onMouseUp={() => clearTimeout(window._forfait1Timeout)}
            onTouchStart={() =>
              (window._forfait1Timeout = handleForfait1Press())
            }
            onTouchEnd={() => clearTimeout(window._forfait1Timeout)}
            onClick={handleForfait1Click}
            className={`${
              forfaitActif1 ? "bg-red-800" : "bg-red-500"
            } hover:bg-red-700 
     px-2 sm:px-3 py-1 rounded flex items-center justify-center 
     space-x-0 sm:space-x-2 mt-2 text-xs sm:text-sm`}
            aria-label="Forfait"
          >
            <FaMedkit className="text-lg sm:text-xl" />
            {/* Texte caché sur mobile, visible à partir de sm */}
            <span className="hidden sm:inline">Forfait</span>
          </button>
        </div>
        <OsaekomiComponent
          osaekomi={osaekomi1}
          setOsaekomi={setOsaekomi1}
          tapisId={tapisId}
          competiteur={1}
          score={score1}
          setScore={setScore1}
          playGongSound={playGongSound}
          wazariAwaseteIppon={wazariAwaseteIppon}   // ✅ AJOUT
        />
      </div>

      <ScoreComponent
        competiteur={competiteur2}
        score={score2}
        setScore={setScore2}
        tapisId={tapisId}
        isRed={false}
        wazariAwaseteIppon={wazariAwaseteIppon}
      />
      <div className="flex justify-between">
        <div className="flex justify-center items-center gap-2 sm:space-x-4 sm:gap-0">
          <PenaliteComponent
            penalites={penalites2}
            setPenalites={setPenalites2}
            tapisId={tapisId}
            competiteur={2}
          />
          <button
            onMouseDown={() =>
              (window._forfait2Timeout = handleForfait2Press())
            }
            onMouseUp={() => clearTimeout(window._forfait2Timeout)}
            onTouchStart={() =>
              (window._forfait2Timeout = handleForfait2Press())
            }
            onTouchEnd={() => clearTimeout(window._forfait2Timeout)}
            onClick={handleForfait2Click}
            className={`text-sm ${
              forfaitActif2 ? "bg-red-800" : "bg-red-500"
            } hover:bg-red-700 px-3 py-1 rounded flex items-center space-x-2 mt-2`}
          >
            <FaMedkit className="text-lg sm:text-xl" />
            {/* Texte caché sur mobile, visible à partir de sm */}
            <span className="hidden sm:inline">Forfait</span>
          </button>
        </div>
        <OsaekomiComponent
          osaekomi={osaekomi2}
          setOsaekomi={setOsaekomi2}
          tapisId={tapisId}
          competiteur={2}
          score={score2}
          setScore={setScore2}
          playGongSound={playGongSound}
          wazariAwaseteIppon={wazariAwaseteIppon}
        />
      </div>

      {/* ⬇️ NOTE : on passe les setters “safe” pour marquer l’interaction */}
      <MainChronoComponent
        chrono={chrono}
        setChrono={setChronoSafe}
        isChronoRunning={isChronoRunning}
        setIsChronoRunning={setIsChronoRunningSafe}
        playGongSound={playGongSound}
        score1={score1}
        score2={score2}
        initialChrono={chronoMax}
        goldenScoreMode={goldenScoreMode}
        setGoldenScoreMode={setGoldenScoreMode}
        goldenChrono={goldenChrono}
        setGoldenChrono={(v) => {
          userTouchedChronoRef.current = true;
          setGoldenChrono(v);
        }}
      />

      <ControlButtonsComponent
        setModalVisible={setModalVisible}
        setChrono={setChronoSafe}
        chronoMax={chronoMax}
        setIsChronoRunning={setIsChronoRunningSafe}
        setScore1={setScore1}
        setScore2={setScore2}
        setPenalites1={setPenalites1}
        setPenalites2={setPenalites2}
        setOsaekomi1={setOsaekomi1}
        setOsaekomi2={setOsaekomi2}
        playGongSound={playGongSound}
        setGoldenScoreMode={setGoldenScoreMode}
        setGoldenChrono={(v) => {
          userTouchedChronoRef.current = true;
          setGoldenChrono(v);
        }}
        setForfaitActif1={setForfaitActif1}
        setForfaitActif2={setForfaitActif2}
        competitionId={competitionId}
        tapisId={tapisId}
      />

      <DetermineWinnerModal
        isVisible={modalVisible}
        onClose={() => setModalVisible(false)}
        score1={score1}
        score2={score2}
        competiteur1={competiteur1}
        competiteur2={competiteur2}
        penalites1={penalites1}
        penalites2={penalites2}
        onValidate={handleValidate}
      />
      <ToastContainer />
    </div>
  );
};

export default ScoreboardAdmin;
